export const DOWNLOAD = 'DOWNLOAD'
export const SAVED_SEARCHES = 'SAVED_SEARCHES'
